module.exports = __webpack_public_path__ + "img/strategy-lightning.9df47057.svg";